import required from 'utils/validation/required';
import {
  validateFieldSync,
  validateFormSync,
} from 'utils/validation/validate-generators';
import { otpCodeFieldName } from '../otp-modal-partials.config';

export function useOptFormConfig() {
  return {
    initialValues: {
      [otpCodeFieldName]: '',
    },
    validate: validateFormSync({
      [otpCodeFieldName]: validateFieldSync(required),
    }),
  };
}
